import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import useInterestRate from '../../../../../../hooks/useInterestRate';

const MonthlyInterestContainer: FC = () => {
  const interestRate = useInterestRate();

  if (!interestRate) {
    return null;
  }

  return <Rate labelId={RateTypes.INTEREST_RATE} value={`${interestRate}%`} />;
};

export default MonthlyInterestContainer;
